import { NavLink } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Home() {
    return (
        <header className="siteHeader wrapper">
            <h1>Caitlin Klotz</h1>

            <ul>
                <li>
                    <NavLink to="/acting">Actress</NavLink>
                </li>
                <li>
                    <NavLink to="/music">Musician</NavLink>
                </li>
            </ul>

            <div className="socials">
                <div>
                    <a href="https://open.spotify.com/artist/7K7E5F2950LM3k0TSOdubf">
                        <FontAwesomeIcon
                            icon="fa-brands fa-spotify"
                            className="icon"
                        />
                    </a>
                    <a href="https://music.apple.com/artist/1790138283">
                        <FontAwesomeIcon
                            icon="fa-brands fa-itunes-note"
                            className="icon"
                        />
                    </a>
                    <a href="https://www.youtube.com/@caitlin.klotz.1">
                        <FontAwesomeIcon
                            icon="fa-brands fa-youtube"
                            className="icon"
                        />
                    </a>
                    <a href="https://music.amazon.ca/artists/B0DSW3SBWT/caitlin-klotz?marketplaceId=A2EUQ1WTGCTBG2&musicTerritory=CA&ref=dm_sh_ajRpylatpWUzTQWseZzZA9tAM">
                        <FontAwesomeIcon
                            icon="fa-brands fa-amazon"
                            className="icon"
                        />
                    </a>
                </div>
                <div>
                    <a href="https://www.instagram.com/caitlin.klotz.1">
                        <FontAwesomeIcon
                            icon="fa-brands fa-instagram"
                            className="icon"
                        />
                    </a>
                    <a href="https://www.threads.com/@caitlin.klotz.1">
                        <FontAwesomeIcon
                            icon="fa-brands fa-threads"
                            className="icon"
                        />
                    </a>
                    <a href="https://www.facebook.com/caitlin.klotz.2">
                        <FontAwesomeIcon
                            icon="fa-brands fa-facebook"
                            className="icon"
                        />
                    </a>
                    <a href="https://twitter.com/CaitlinKlotz">
                        <FontAwesomeIcon
                            icon="fa-brands fa-x-twitter"
                            className="icon"
                        />
                    </a>
                </div>
            </div>
        </header>
    );
};

export default Home;